module.exports = __webpack_public_path__ + "img/domain-07.b24f431d.png";